/**
 * Reports page — analyst-portal vetting surface.
 *
 * Two routes share this page:
 *   /reports           → ReportQueue (list + filters)
 *   /reports/:reportId → ReportEditor (preview + checklist + custom content + actions)
 *
 * "Generate" lives at /reports/generate (separate route, separate page) but the
 * queue links into it via a top-right button.
 */

import { useNavigate, useParams, Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '../components/ui';
import { ReportQueue, ReportEditor } from '../components/reporting';

export function Reports() {
  const { reportId } = useParams<{ reportId: string }>();
  const navigate = useNavigate();

  if (reportId) {
    return (
      <div className="p-6 max-w-[1400px] mx-auto">
        <ReportEditor
          reportId={reportId}
          onBack={() => navigate('/reports')}
          onReportUpdate={() => {
            /* the editor reloads itself; no extra plumbing needed */
          }}
        />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-[1400px] mx-auto space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold text-text-primary">Reports</h1>
          <p className="text-sm text-text-secondary mt-1">
            Vet AI-authored monthly reports before they're published to customers.
          </p>
        </div>
        <Link to="/reports/generate">
          <Button variant="primary">
            <Plus className="w-4 h-4 mr-1" />
            Generate report
          </Button>
        </Link>
      </div>

      <ReportQueue onSelect={(id) => navigate(`/reports/${id}`)} />
    </div>
  );
}
